export enum FreelancersProfilesSortField {
	CreatedAt = "CreatedAt",
	UpdatedAt = "UpdatedAt",
	FirstName = "FirstName",
	LastName = "LastName",
	Country = "Country",
	City = "City",
	DailyRateMin = "DailyRateMin",
	DailyRateMax = "DailyRateMax"
}
